import { render } from "./UserSecurityGroupAssocHistoryModal.vue?vue&type=template&id=01ef5a20&ts=true"
import script from "./UserSecurityGroupAssocHistoryModal.vue?vue&type=script&lang=ts"
export * from "./UserSecurityGroupAssocHistoryModal.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__